/**
 * ThermostatSetMode Style01 - Mode selector for AC/HVAC modal
 * modes from attributes.availableThermostatModes
 */
import { useMemo } from 'react'
import type { TraitControlProps } from './types'
import { resolveModesFromAttributes } from './traitStyleConfig'
import { THERMOSTAT_MODE_CONFIG } from '../traits/types'

const DEFAULT_MODES = ['cool', 'heat', 'dry', 'fan-only', 'auto']
const LABELS: Record<string, string> = { cool: 'Cool', heat: 'Heat', dry: 'Dry', 'fan-only': 'Fan', auto: 'Auto' }

export function ThermostatSetModeStyle01({
  trait,
  state,
  attributes,
  onCommand,
  disabled = false,
}: TraitControlProps) {
  const modeIds = useMemo(() => {
    const ids = resolveModesFromAttributes(attributes, trait)
    const arr = Array.isArray(ids) ? ids : []
    return arr.length ? arr : DEFAULT_MODES
  }, [attributes, trait])
  const raw = (state?.thermostatMode ?? state?.mode ?? state?.currentModeSettings) as string | undefined
  const current = typeof raw === 'string' ? raw.toLowerCase() : 'cool'
  const normalized = modeIds.includes(current) ? current : (modeIds[0] ?? 'cool')

  return (
    <div className="smart-home-automation-field">
      <label>Mode</label>
      <div className="smart-home-automation-command-row smart-home-automation-mode-row">
        {modeIds.map((id) => {
          const cfg = THERMOSTAT_MODE_CONFIG[id] ?? { label: { en: LABELS[id] ?? id }, icon: 'tune' }
          const label = (cfg.label as { en?: string })?.en ?? LABELS[id] ?? id
          return (
          <button
            key={id}
            type="button"
            className={`smart-home-automation-command-btn glass ${normalized === id ? 'active' : ''}`}
            onClick={() => !disabled && onCommand('setMode', { mode: id })}
            disabled={disabled}
          >
            <span className="material-symbols-outlined">{cfg.icon}</span>
            {label}
          </button>
        )})}
      </div>
    </div>
  )
}
